module.exports = __webpack_public_path__ + "static/rilli-9f811a19e2de5a4e58dc69e3b90d09e7.gif";